import React, { Component } from 'react';
import './Style.css';
import NotFound from '../../../images/empty.svg';
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';

export class Plan extends Component {

    constructor(props) {
        super(props);
        this.state = {
            myPlanList: [],
            planFeatured: [],
            topics: [],
            myCreations: [],
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            },
        }

    }

    componentDidMount() {
        this.GetAllTopicsActive();
        this.GetPlanSubscribe();
        this.GetPlanFeature();
        this.GetMyCreations();
    }

    async GetAllTopicsActive() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Topic/GetAllTopicsActive`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ topics: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los temas',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }
    async GetPlanSubscribe() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/GetSubscribePlanByUserId`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ myPlanList: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Usuario y/o contraseña inválidos.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }
    async GetPlanFeature() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/GetFeatures`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ planFeatured: data });

        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Usuario y/o contraseña inválidos.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }
    async GetMyCreations() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/MyCreations`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ myCreations: data });

        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando mis planes',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async InsertPlanToUser(activity) {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },

            body: JSON.stringify({
                PlanId: this.state.selectedPlanId,
                Activity: activity
            })
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/InsertPlanToUser`, request);

        this.setState({ loading: false });
        document.querySelector('#btnCloseAddPlan').click();

        if (response.status == 200) {

            const data = await response.json();
            window.location.href = `/comunidad/plan/detalle/${data.id}`;

            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'Te has activado a este plan correctamente',
                    Type: 'alert-success',
                    Show: true
                }
            });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No se puedo registrar el plan',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async removePlan() {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` }
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/Remove?planId=${this.state.removeId}`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'Plan elminado con correctamente',
                    Type: 'alert-success',
                    Show: true
                }
            });
            this.GetMyCreations();
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'no se pudo eliminar el plan',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    render() {

        return (
            <div className="mt-5">

                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/comunidad">Inicio</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Planes</li>
                    </ol>
                </nav>

                <div class="tabs">
                    <div class="tab-button-outer">
                        <ul id="tab-button">
                            <li><a href="#tab01">Mis planes</a></li>
                            <li><a href="#tab02" onClick={() => { window["setSlick"]('.plan-features', 1, false); window["setSlick"]('.topics', 5, true); }} >Navegador de planes</a></li>
                        </ul>
                    </div>

                    <div id="tab01" class="tab-contents">


                        <div class="row">
                            <div class="col-12">

                                <ul class="list-group">
                                    {
                                        this.state.myPlanList.map(e => {
                                            if (e.progressValues < 100) {
                                                return (<li class="list-group-item ecard-plan">
                                                    <div class="image-parent w-50 align-middle d-inline-block">
                                                        <a className="" href={`/comunidad/plan/detalle/${e.id}`} >
                                                            <img src={e.photo} class="img-fluid mi-plan" alt={e.title} />
                                                        </a>
                                                    </div>
                                                    <div className="w-50 align-middle d-inline-block text-left pl-3">
                                                        <a className="" href={`/comunidad/plan/detalle/${e.id}`} >{e.title}</a>
                                                        <div class="progress mt-3 mb-3">
                                                            <div class="progress-bar" role="progressbar" style={{ "width": parseInt(e.progressValues) + '%' }} aria-valuenow={parseInt(e.progressValues)} aria-valuemin="0" aria-valuemax="100">{parseInt(e.progressValues)}%</div>
                                                        </div>

                                                        <a className="btn" href={`/comunidad/plan/detalle/${e.id}`} >Progreso</a>
                                                    </div>
                                                </li>)
                                            }
                                        }
                                        )
                                    }
                                </ul>
                            </div>
                        </div>


                        <div class="accordion" id="accordionExample">
                            <div class="card">
                                <div class="card-header" id="headingOne">
                                    <h2 class="mb-0">
                                        <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            Planes completados
                                        </button>
                                    </h2>
                                </div>

                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                    <div class="card-body">

                                        <div class="row">
                                            <div class="col-12">

                                                {
                                                    this.state.myPlanList.length == 0 ? <h5>Aún no completas ningún plan</h5> : null
                                                }



                                                <ul class="list-group">
                                                    {
                                                        this.state.myPlanList.map(e => {
                                                            if (e.progressValues == 100) {
                                                                return (<li class="list-group-item d-flex align-items-center ecard-plan">
                                                                    <div class="image-parent">
                                                                        <img src={e.photo} class="img-fluid mi-plan" alt={e.title} />
                                                                    </div>
                                                                    <div className="no-flex ml-4">
                                                                        {e.title}<br />
                                                                        <div class="progress">
                                                                            <div class="progress-bar" role="progressbar" style={{ "width": parseInt(e.progressValues) + '%' }} aria-valuenow={parseInt(e.progressValues)} aria-valuemin="0" aria-valuemax="100">{parseInt(e.progressValues)}%</div>
                                                                        </div>
                                                                    </div>
                                                                </li>)
                                                            }
                                                        }
                                                        )
                                                    }
                                                </ul>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div id="tab02" class="tab-contents">

                        {
                            this.state.planFeatured.length == 0 ?
                                <div className="align-middle text-center">
                                    <img className="not-found" src={NotFound} />
                                    <h4 className="mt-5">No hay planes destacados</h4>
                                </div> :
                                null
                        }

                        <div class="slider plan-features">

                            {this.state.planFeatured.map(e =>

                                <div class="list-group-item align-items-center">
                                    <div class="image-parent">
                                        <img src={e.photo} class="w-100" alt={e.title} />
                                    </div>
                                    <div className="no-flex mt-3">
                                        {e.title}
                                    </div>
                                    <button type="button" class="btn btn-primary mt-2" data-toggle="modal" data-target="#subscribePlanModal" onClick={() => {
                                        this.setState({ selectedPlanId: e.id });
                                    }} >
                                        Iniciar
                                    </button>
                                </div>
                            )}
                        </div>

                        <div class="slider topics mt-5">

                            {this.state.topics.map(e =>

                                <div className="mr-2">
                                    <a className="btn btn-outline-secondary" href={`/comunidad/tema/${e.id}`}>{e.title}</a>
                                </div>

                            )}
                        </div>



                        <div class="row my-plans mt-5">
                            <div class="col-12 text-center">
                                {this.state.myCreations.length > 0 ? <h2> Mis creaciones</h2> : null}
                            </div>
                            <div class="col-12">

                                <ul class="list-group">

                                    {
                                        this.state.myCreations.map(e =>
                                            <li class="list-group-item d-flex align-items-center ecard-plan">
                                                <div class="image-parent w-50 align-middle d-inline-block">
                                                    <a className="" href={`/comunidad/plan/form/${e.id}`} ><img src={e.photo} class="img-fluid mi-plan" alt={e.title} /></a>
                                                </div>
                                                <div className="w-50 align-middle d-inline-block text-left pl-3">
                                                    <label>{e.title}</label>

                                                    {
                                                        e.status != 'Publicado' ?
                                                            <div>
                                                                <a className="button-plan-more mr-3" href={`/comunidad/plan/form/${e.id}`} >Editar</a>
                                                                <a type="button" href="#" data-toggle="modal" data-target="#exampleModalCenter" onClick={() => { this.setState({ removeId: e.id }) }}>
                                                                    Borrar
                                                                </a>
                                                            </div>
                                                            :
                                                            <div>Publicado</div>
                                                    }
                                                </div>
                                            </li>
                                        )
                                    }

                                </ul>
                            </div>
                        </div>

                        <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLongTitle">Confirmar plan</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        Está seguro que desea borrar este plan?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                                        <button type="button" class="btn btn-primary" data-dismiss="modal" onClick={() => { this.removePlan(); }}>Sí, borrar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="add-plan-wrapp">
                            <a className="add-plan" href="/comunidad/plan/form">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-send-plus-fill" viewBox="0 0 16 16">
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>


                <div class="modal fade" id="subscribePlanModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Seguir plan</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                ¿Deseas que la comunidad vea la actividad de tú plan?
                            </div>
                            <div class="modal-footer">

                                <a href="javascript:void(0);" onClick={() => {
                                    this.InsertPlanToUser('Friends');
                                }}>Visible para amigos</a>

                                <a href="javascript:void(0);" onClick={() => {
                                    this.InsertPlanToUser('Private');
                                }}>Privado</a>

                                <a href="javascript:void(0);" id="btnCloseAddPlan" data-dismiss="modal">Cancelar</a>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }} /> : null}
                {this.state.loading ? <Loading /> : null}

            </div >
        );
    }
}
